import React, { useState } from 'react';
import { ExclamationCircleIcon } from '@panwds/icons';
import { Body } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { Pill } from '../Pill/Pill.esm.js';
import '../Pill/PillValue.esm.js';
import { TextInput } from './TextInput.esm.js';

const TextInputFilter = ({ errorMessage, name, label, onClose, onValidate, ...rest }) => {
    const { filters, setFilters } = useFilters();
    const filterValue = filters[name];
    const [errorLabel, setErrorLabel] = useState();
    /** An optional function for input validation */
    const handleValueSubmit = (value) => {
        if (onValidate) {
            onValidate(value)
                ? (setFilters({ [name]: value }), setErrorLabel(""))
                : setErrorLabel(errorMessage);
        }
        else {
            setFilters({ [name]: value });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Pill, { label: label, onClose: onClose, required: rest.required, select: React.createElement(TextInput, { ...rest, onValueSubmit: handleValueSubmit, filterValue: filterValue, noBorder: true }) }),
        onValidate && (React.createElement("label", { className: "tw-flex tw-items-center tw-text-red dark:tw-text-red-400 tw-m-0 tw-pl-2 tw-pt-1" },
            errorLabel && React.createElement(ExclamationCircleIcon, { size: "xs" }),
            React.createElement(Body, { addClassName: "tw-ml-1 tw-font-lato tw-text-xs" }, errorLabel)))));
};

export { TextInputFilter };
//# sourceMappingURL=TextInputFilter.esm.js.map
